window.addEventListener('load', function() {

  const productGrid = document.querySelector("#product-grid");

  const linkModeRow = document.querySelector(".viewModeRow");
  const linkModeRowMobile = document.querySelector(".viewModeRow-mobile");
  linkModeRow.addEventListener("click", activateRowView);
  linkModeRowMobile.addEventListener("click", activateRowView);

  const linkModeCards = document.querySelector(".viewModeCards");
  const linkModeCardsMobile = document.querySelector(".viewModeCards-mobile");
  linkModeCards.addEventListener("click", activateCardsView);
  linkModeCardsMobile.addEventListener("click", activateCardsView);

  // console.log(linkModeRow);

  function activateRowView() {
    // console.log("activateRowView");
    productGrid.classList.add("listView");
    productGrid.classList.remove("gridView");
    linkModeRow.classList.add("active");
    linkModeRowMobile.classList.add("active");
    linkModeCards.classList.remove("active");
    linkModeCardsMobile.classList.remove("active");

    localStorage.setItem("viewPreference", "row");
  }

  function activateCardsView() {
    // console.log("activateCardsView");
    productGrid.classList.remove("listView");
    productGrid.classList.add("gridView");
    linkModeRow.classList.remove("active");
    linkModeRowMobile.classList.remove("active");
    linkModeCards.classList.add("active");
    linkModeCardsMobile.classList.add("active");

    localStorage.setItem("viewPreference", "grid");
  }
  
  // Function to initialize the view based on the saved preference from localStorage
  function initializeView() {
    const savedView = localStorage.getItem("viewPreference");
    
    if (savedView) {
      if(savedView == "row") {
        activateRowView();
      } else {
        activateCardsView();
      }
    } else {
      // Default view type (rows) if no preference is saved
      activateCardsView();
    }
  }

  initializeView();
});